import './index.scss'
$(".product-nav dl dt").click(function() {
    $(this).toggleClass("active");
    $(this).parent().find(".dd").slideToggle();
})
var oTable = $('table');
if (oTable.length !== 0) {
    var oTr = oTable.find('tr'),
        oTd = oTable.find('td');

    oTable.wrap("<div class='table-box'></div>");
    oTr.attr('style', '');
    if (oTable.find("td[style='text-align: center']").length !== 0) {
        oTd.attr('style', '');
        oTd.css({
            'text-align': 'center',
        });
    } else {
        oTd.attr('style', '');
    }
}